module.exports = "/layout/app/images/bg-section-why-choose-us-after.708e47d1.svg";